import React, { useState } from "react";
import Text from "../../Tags/Text";
import { Badge } from "../../ui/badge";
import { useTableData } from "../../../hooks/useTableData";
import { getBillingHistory } from "../../../apis/workspace/billing";
import { isEmptyObject, returnArray } from "../../../utils/GenericFn";
import Filter from "../../Filter";
import EditColumn from "../../EditColumn";
import { ArrowDown, ArrowUp, DownloadCloud } from "lucide-react";
import PrintDate from "../../Tags/PrintDate";
import TableLoader from "../../Loaders/TableLoader";
import NoData from "../../NoData";
import Pagination from "../../Pagination";
import BadgeTag from "../../Tags/BadgeTag";
import { Button } from "../../ui/button";

export default function BillingHistory({ activeWorkspace }) {
  const [billingHistory, setBillingHistory] = useState({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const {
    data,
    paginationInfo,
    filterMetadata,
    columnMetadata,
    apiResponse,
    isLoading,
    isFetching,
    isFetched,
    isSuccess,
    isError,
    filters,
    sort,
    pagination,
    columns,
    sortedVisibleColumns,
    getPageNumber,
    getFiltersObject,
    handleSetSort,
    getColumns,
  } = useTableData({
    queryKey: "get_calls_list",
    fetchFn: getBillingHistory,
    defaultHeaders: { "X-Workspace-Id": activeWorkspace?.id },
    enabled: !!activeWorkspace?.id,
    onSuccess: (data) => {
      //   const mappedData = mapApiResponseToTableData(data);
      console.log("data", data);
      setBillingHistory(data);
      setIsInitialLoad(false);

      console.log("Fetched!", data);
    },
    onError: (error) => {
      console.error("CallLogs API error:", error);
      if (error?.status === 403 || error?.response?.status === 403) {
        setIsInitialLoad(false);
      } else {
      }
    },
  });

  const renderCellContent = (columnKey, item) => {
    console.log("columnKey", columnKey);
    switch (columnKey) {
      case "invoice_number":
        return (
          <a href={item?.hosted_invoice_url} target="_blank" className="font-bold text-brand-600">
            {item?.invoice_number}
          </a>
        );
      case "date":
        return item?.date ? <PrintDate date={item?.date} showTime={true} /> : "-";

      case "due_date":
        return item?.due_date ? <PrintDate date={item?.due_date} showTime={true} /> : "-";

      case "status":
        return (
          <>
            <BadgeTag text={item.status} dot className="rounded-md" />
          </>
        );
      default:
        return item?.[columnKey] || "-";
    }
  };

  return (
    <div>
      <Text size="lg">Billing history</Text>
      {billingHistory?.data && (billingHistory.data.length > 0 || !isEmptyObject(filters)) && (
        <div className="flex justify-between items-center mt-4">
          <div className="space-x-3 inline-flex items-center">
            {billingHistory.filterMetadata && (
              <>
                <span className="text-sm text-gray-500">Filters:</span>
                <Filter filterMetadata={billingHistory.filterMetadata} getFiltersObject={getFiltersObject} />
              </>
            )}
          </div>
          <div className="space-x-3">
            {billingHistory.columnMetadata && (
              <EditColumn columnMetadata={billingHistory.columnMetadata} getColumns={getColumns} />
            )}
          </div>
        </div>
      )}
      {billingHistory?.data && billingHistory.data.length > 0 && isSuccess && (
        <div className="mt-6 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden border border-border rounded-[--radius]">
                <table className="min-w-full divide-y divide-border table-fixed">
                  <thead className="bg-gray-100">
                    <tr>
                      {returnArray(sortedVisibleColumns).map((column, index) => (
                        <th
                          key={index}
                          scope="col"
                          className={`px-3 py-3.5 text-left text-xs font-medium text-text-600 ${
                            column.key === "user_name" ? "w-1/4" : ""
                          } ${column.sortable ? "cursor-pointer" : ""}`}
                          onClick={() => (column.sortable ? handleSetSort(column.key) : void 0)}
                        >
                          <span className={"inline-flex items-center"}>
                            {column.display_name}
                            {column.sortable && (
                              <>
                                {sort === `-${column.key}` ? (
                                  <ArrowDown className="inline-block ml-1 h-3 w-3" />
                                ) : sort === column.key ? (
                                  <ArrowUp className="inline-block ml-1 h-3 w-3" />
                                ) : (
                                  <ArrowDown className="inline-block ml-1 h-3 w-3 opacity-50" />
                                )}
                              </>
                            )}
                          </span>
                        </th>
                      ))}
                      <th scope="col" className="!px-3 !py-4 text-left text-sm font-medium" />
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border bg-background">
                    {billingHistory.data &&
                      billingHistory.data.length > 0 &&
                      returnArray(billingHistory.data).map((item, index) => (
                        <tr key={item.id} className={`hover:bg-gray-50  ${index % 2 !== 0 ? "" : ""}`}>
                          {returnArray(sortedVisibleColumns).map(({ key: colKey }) => (
                            <td
                              key={colKey}
                              className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 dark:text-[#F7F7F7] "
                            >
                              {renderCellContent(colKey, item)}
                            </td>
                          ))}
                          <td className="whitespace-nowrap  px-3 py-4">
                            <div className="text-right">
                              <div className="inline-block text-left w-[130px]">
                                {item?.status?.toLowerCase() === "open" ? (
                                  <Button>
                                    <a href={item?.hosted_invoice_url} target="_blank">
                                      Make payment
                                    </a>
                                  </Button>
                                ) : (
                                  <a href={item?.invoice_pdf} className="inline-block cursor-pointer ">
                                    <DownloadCloud
                                      className="text-gray-500 pointer-events-none"
                                      width={20}
                                      height={20}
                                    />
                                  </a>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {(isLoading || isInitialLoad) && <TableLoader />}

      {billingHistory?.data?.length === 0 && !isLoading && !isError && <NoData title="No data found" />}

      {/* Pagination */}
      <div className="flex items-center justify-between rounded-[--radius] py-3">
        <div className="flex-1">
          {billingHistory.pagination && billingHistory.pagination.total > 0 && (
            <Pagination data={billingHistory.pagination} getPageNumber={getPageNumber} />
          )}
        </div>
      </div>
    </div>
  );
}
